/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader } from '@zeeve-platform/loader-component';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import RightButtons from '../../common/buttons/addButtonComponent';
import Urls from '../../../utils/urls';

import { prefixPath } from '../../../utils/helpers';
import BaseUrls from '../../../utils/baseUrls';
import { networkDataInterface } from '../../viewNetwork/dedicatedNetwork/allNetworkBody';
import { endpointDataInterface } from '../../viewAllEndpoint/allEndpointBody';
import NetworkCard from '../../common/cards/networkCard';
import EndpointCard from '../../common/cards/endpointCards';
import apiBackendInstance from '../../../utils/axios';

const WorskspaceResourceBody = ({ theme, workspaceId, workspaceName }: { theme: string, workspaceId: string, workspaceName: any }) => {
  const [networkData, setNetworkData] = useState<networkDataInterface[]>([]);
  const [endpointData, setEndpointData] = useState<endpointDataInterface[]>([]);
  const [showLoader, setShowLoader] = useState(true);
  const loaderImageUrl = window.location.origin + prefixPath(`/img/${theme}/spin.svg`);
  const [networkDataCount, setNetworkDataCount] = useState(0);
  const [endpointDataCount, setEndpointDataCount] = useState(0);
  const [preNetworkDataCount, setPreNetworkDataCount] = useState(0);
  const [preEndpointDataCount, setPreEndpointDataCount] = useState(0);
  const [showPagination, setShowPagination] = useState(false);
  const [showNext, setShowNext] = useState(false);

  async function getPage(endpointCount: number, networkCount: number): Promise<boolean> {
    try {
      setShowLoader(true);
      const response = await apiBackendInstance.get(Urls.getWorkspaceResources(workspaceId, endpointCount, networkCount), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      if (response && response.data && response.data.data && response.data.data.list) {
        let netcount = 0;
        let endCount = 0;
        const netarr: networkDataInterface[] = [];
        const endarr: endpointDataInterface[] = [];
        response.data.data.list.forEach((e: any) => {
          if (e.type === 'network') {
            netarr.push(e);
            netcount += 1;
          } else {
            endarr.push(e);
            endCount += 1;
          }
        });
        setShowNext(response.data.data.next);
        setNetworkData(netarr);
        setEndpointData(endarr);
        setPreEndpointDataCount(response.data.endpoints);
        setPreNetworkDataCount(response.data.networks);
        setEndpointDataCount(endCount);
        setNetworkDataCount(netcount);
      }
      setShowLoader(false);
      return true;
    } catch (error) {
      setShowLoader(false);
      console.log(error);
    }
    return false;
  }

  useEffect(() => {
    setShowLoader(true);
    apiBackendInstance.get(Urls.getWorkspaceResources(workspaceId, 0, 0), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data) {
        let netcount = 0;
        let endCount = 0;
        const netarr: networkDataInterface[] = [];
        const endarr: endpointDataInterface[] = [];
        response.data.data.list.forEach((e: any) => {
          if (e.type === 'network') {
            netarr.push(e);
            netcount += 1;
          } else {
            endarr.push(e);
            endCount += 1;
          }
        });
        setNetworkData(netarr);
        setEndpointData(endarr);
        setEndpointDataCount(endCount);
        setNetworkDataCount(netcount);
        setShowPagination(endCount > 0 || netcount > 0);
        setPreEndpointDataCount(response.data.data.endpoints);
        setPreNetworkDataCount(response.data.data.networks);
      }
      setShowLoader(false);
    }).catch(() => {
      setNetworkData([]);
      setEndpointData([]);
      setShowLoader(false);
    });
  }, []);
  const imgSubPath = window.location.origin;
  const addIconImg = imgSubPath + prefixPath(`/img/${theme}/add-icon.png`);
  const toDedicatedSubscriptions = prefixPath('/network/subscriptions');
  const toEndpointSubscriptions = prefixPath('/endpoint/subscriptions');
  const paths = [{ name: 'Workspaces', path: prefixPath('/workspace') }];
  const workspace_name = localStorage.getItem('workspaceName');
  if (workspaceName) {
    const workspaceUrl = window.location.href.split('/');
    localStorage.setItem('from', 'workspace');
    localStorage.setItem('workspaceName', workspaceName);
    localStorage.setItem('workspace_url', workspaceUrl[workspaceUrl.length - 1]);
  }

  return (
    <section className="px-5 col-12 workspace">
      {showLoader && <Loader imagePath={loaderImageUrl} />}
      <div className="cardBlack">
        <div className="row mt-4 pt-1">
        <div className="col-lg-6 pt-2 col-xl-6 col-sm-12 col-xs-12">
          <p className="fw-bold">
            <Breadcrumb prefixLink={paths} activeLink={workspaceName || workspace_name} />
          </p>
        </div>
          <div className="mt-2 row">
            {
              networkData.map((o, idx) => (
                <NetworkCard
                  cardnumber={idx}
                  total={networkData.length}
                  key={o.id}
                  id={o.id}
                  type={o.type}
                  name={o.name}
                  protocolId={o.protocolId}
                  workspaceId={o.workspaceId}
                  activeNodes={o.activeNodes}
                  inProgressNodes={o.inProgressNodes}
                  inactiveNodes={o.inactiveNodes}
                  frontendBaseSuburl={o.frontendBaseSuburl}
                  customDashboardUrl={o.customDashboardUrl}
                  protocolName={o.protocolName}
                  createdAt={o.createdAt}
                  nodeType={o.nodeType}
                  protocolType={o.protocolType}
                  status={o.status}
                  card_type="workspace"
                />
              ))
            }
            {
              endpointData.map((o, idx) => (
                <EndpointCard
                  cardnumber={idx}
                  total={endpointData.length}
                  key={o.id}
                  id={o.id}
                  type={o.type}
                  name={o.name}
                  protocolId={o.protocolId}
                  workspaceId={o.workspaceId}
                  plan={o.plan}
                  viewableLabels={o.viewableLabels}
                  frontendBaseSuburl={o.frontendBaseSuburl}
                  protocolName={o.protocolName}
                  createdAt={o.createdAt}
                  card_type="workspace"
                />
              ))
            }
          </div>
        </div>
      </div>
      <div className="mb-5 mt-5">
        { showPagination && (
          <div className="mt-5 text-center col-10">
            <button
              type="button"
              disabled={preEndpointDataCount === 0 && preNetworkDataCount === 0}
              className="comingSoon"
              onClick={() => { getPage(Math.max(0, preEndpointDataCount - endpointDataCount), Math.max(0, preNetworkDataCount - networkDataCount)); }}
            >
              Prev
            </button>
            <button
              type="button"
              className="mx-3 comingSoon"
              disabled={!showNext}
              onClick={() => { getPage(preEndpointDataCount + endpointDataCount, preNetworkDataCount + networkDataCount); }}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default WorskspaceResourceBody;
